import { createSlice } from '@reduxjs/toolkit';
import initState from '../../../domain/entities/sesion';

// LOGIN

function craerSesion(state, action) {
  state.token = action.payload.token ? action.payload.token:"";
  state.user = action.payload.user ?  action.payload.user: state.user ;

  if( !sessionStorage.getItem('token') && !sessionStorage.getItem('user')){
    //delete action.payload.user.id;
    delete action.payload.user.idAcount
    delete action.payload.user.idState
    sessionStorage.setItem('token', JSON.stringify(action.payload.token));
    sessionStorage.setItem('user', JSON.stringify(action.payload.user));
  }
  
}

function cerrarSesion(state, action) {
  state.token=null;
  state.user= {
        id: null,
        idAcount: null,
        name: "",
        lastName: "",
        email: "",
        date: "",
        numberId: null,
        userName: "",
        password: "",
        idState: null
    }

    /**control */
    state.connection=false;
    state.error=false;
    state.message="";
    
    sessionStorage.clear();
}

function conexionSesion(state, action) {
  state.connection= action.payload.connection;
}

function errorSesion(state, action) {
  state.error= action.payload.error ? action.payload.error:false;
  state.message= action.payload.message ? action.payload.message:"";
}

// RECOVERY SESION
function recoverPassword(state, action) {
  action.payload.hasOwnProperty('message') && (state.recoverPassword.message = action.payload.message);
  action.payload.hasOwnProperty('result') && (state.recoverPassword.result = action.payload.result);
  action.payload.hasOwnProperty('connection') && (state.recoverPassword.connection = action.payload.connection);
  action.payload.hasOwnProperty('error') && (state.recoverPassword.error = action.payload.error);
}

// CHANGE PASSWORD
function changePassword(state, action) {
  action.payload.hasOwnProperty('message') && (state.changePassword.message = action.payload.message);
  action.payload.hasOwnProperty('result') && (state.changePassword.result = action.payload.result);
  action.payload.hasOwnProperty('connection') && (state.changePassword.connection = action.payload.connection);
  action.payload.hasOwnProperty('error') && (state.changePassword.error = action.payload.error);
}


/**
 * Conexión
 */
const sesionReducer = createSlice({
  name: 'sesion',
  initialState: initState,
  reducers: {
    craerSesion,
    conexionSesion,
    errorSesion,
    cerrarSesion,

    recoverPassword,
    changePassword,
  },
});

export const sesionActions = {
  ...sesionReducer.actions,
};

export default sesionReducer.reducer;
